import { ISpreadsheetData } from 'components/spreadsheet/types'
import { hasSyncStartedThisSession } from 'components/spreadsheet/helpers/syncSession'

/** What the person viewing may do through a Custom View's page. */
export interface PageAccess {
  add: boolean
  edit: boolean
  delete: boolean
}

/** The table view's row settings, applied as the grid applies them (it hides the controls these turn off).
 * A component calling this while rendering passes `syncStartedThisSession` from useSyncStartedThisSession, so it
 * re-renders when a sync starts; the default reads the session directly, which suits event handlers and effects. */
export function rowSettings(
  data: ISpreadsheetData,
  syncStartedThisSession: boolean = hasSyncStartedThisSession(data.tableDetails.publicId)
): { add: boolean; delete: boolean } {
  // A table that has started syncing this session stays closed to new rows, as the grid's add row does.
  const synced = data.tableDetails.isSynced || data.tableDetails.isSyncing || syncStartedThisSession
  return {
    add: !data.viewDetails.disableNewRow && !synced,
    delete:
      !data.tableDetails.isSynced && (data.isAdmin || (data.isContributor && data.viewDetails.allowContributorDelete))
  }
}

/** What this person may do through the page: the same as in the grid, from the row settings and their own role. */
export function pageAccess(data: ISpreadsheetData): PageAccess {
  const rows = rowSettings(data)
  return {
    add: rows.add && data.isContributor,
    edit: data.isContributor,
    delete: rows.delete
  }
}
